import styled from 'styled-components';
//
import colors from 'theme/colors';

const { darkInputBorder, disabledBackground } = colors;

const StyledInput = styled.input((props: { padding?: string; width?: string }) => ({
  fontSize: '14px',
  padding: props.padding ? props.padding : '14px 13px',
  width: props.width ? props.width : '-webkit-fill-available',
  border: `1px solid ${darkInputBorder}`,
  borderRadius: 2,
  ':focus': {
    outline: 'none',
  },
  ':disabled': {
    backgroundColor: disabledBackground,
  },
}));

export default StyledInput;
